import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "navbar navbar-expand-md navbar-dark bg-dark fixed-top" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "btn btn-light mr-auto" }
const _hoisted_4 = {
  class: "container",
  style: {"padding-top":"80px"}
}
const _hoisted_5 = { id: "MeetingQuestion" }
const _hoisted_6 = {
  key: 1,
  class: "d-flex justify-content-center",
  style: {"padding-top":"200px"}
}
const _hoisted_7 = {
  key: 2,
  class: "d-flex justify-content-center",
  style: {"padding-top":"200px"}
}
const _hoisted_8 = { class: "card" }
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = { class: "btn btn-secondary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MeetingQuestionReview = _resolveComponent("MeetingQuestionReview")!
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.viewTemplate === 'default')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("nav", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_3, [...(_cache[0] || (_cache[0] = [
                _createElementVNode("i", {
                  class: "fa fa-angle-double-left",
                  "aria-hidden": "true"
                }, null, -1 /* CACHED */),
                _createTextVNode(" My Survey ", -1 /* CACHED */)
              ]))])), [
                [_directive_sanitizedHref, _ctx.dashboardUrl]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_MeetingQuestionReview, {
                propIsMeetingManager: false,
                propRm: _ctx.question,
                onUpdateVoteValue: _ctx.handleSavePanelistVoteCommand,
                onUpdateVoteComment: _ctx.handleSavePanelistVoteCommentCommand
              }, null, 8 /* PROPS */, ["propRm", "onUpdateVoteValue", "onUpdateVoteComment"])
            ])
          ])
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true),
    (_ctx.viewTemplate === 'connecting')
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[1] || (_cache[1] = [
          _createStaticVNode("<div class=\"card\"><div class=\"card-body\"><h5 class=\"card-title\"><i class=\"fa fa-spinner fa-spin\"></i> Connecting...</h5><p class=\"card-text lead\">We are checking if meeting was started by the host.</p><br></div></div>", 1)
        ]))]))
      : _createCommentVNode("v-if", true),
    (_ctx.viewTemplate === 'notStarted')
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _cache[3] || (_cache[3] = _createElementVNode("h5", { class: "card-title" }, "Meeting is not started", -1 /* CACHED */)),
              _cache[4] || (_cache[4] = _createElementVNode("p", { class: "card-text lead" }, "Please wait for the host to start this meeting.", -1 /* CACHED */)),
              _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1 /* CACHED */)),
              _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_10, [...(_cache[2] || (_cache[2] = [
                _createTextVNode("Go to the survey", -1 /* CACHED */)
              ]))])), [
                [_directive_sanitizedHref, _ctx.dashboardUrl]
              ])
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}